import { ClientsNavigation } from '@src/routing/ClientsNavigation';
import { OrdersNavigation } from '@src/routing/OrdersNavigation';
import { SettingsNavigation } from '@src/routing/SettingsNavigation';
import { UsersNavigation } from '@src/routing/UsersNavigation';

export const Navigation = {
  home: '/',
  login: '/login',
  confirmResetPassword: '/confirm-reset-password',
  forgotPassword: '/forgot-password',
  changeTemporaryPassword: '/change-temporary-password',
  orderDetails: {
    searchParamKey: 'order',
    searchParam: (orderId: string) => `order=${orderId}`,
  },
  orderList: {
    tabSearchParamKey: 'tabIndex',
    pageSearchParamKey: 'page',
    pageSizeSearchParamKey: 'pageSize',
  },
  orderMode: {
    searchParamKey: 'mode',
  },
  permit: {
    searchParamKey: 'permitId',
    notes: {
      PATH: `order=:orderId&mode=permitNotes&permitId=:permitId`,
      url: (orderId: string, permitId: string) =>
        `/?order=${orderId}&permitId=${permitId}&mode=permitNotes`,
    },
  },
  reviewPermitNotes: {
    searchParamKey: 'permitId',
    notes: {
      PATH: `order=:orderId&mode=reviewPermitNotes&permitId=:permitId`,
      url: (orderId: string, permitId: string) =>
        `/?order=${orderId}&permitId=${permitId}&mode=reviewPermitNotes`,
    },
  },
  users: UsersNavigation,
  orders: OrdersNavigation,
  clients: ClientsNavigation,
  permitSearch: '/permits',
  reports: '/reports',
  permitTypesManager: {
    PATH: '/permitTypesManager',
    addType: {
      PATH: `/permitTypesManager/addType`,
      duplicateFromQueryParam: 'duplicateFrom',
      url: (duplicateFromId?: string) =>
        duplicateFromId
          ? `/permitTypesManager/addType?duplicateFrom=${duplicateFromId}`
          : `/permitTypesManager/addType`,
    },
    editType: {
      PATH: `/permitTypesManager/editType/:permitTypeId`,
      url: (permitTypeId: string) =>
        `/permitTypesManager/editType/${permitTypeId}`,
    },
  },
  settings: SettingsNavigation,
  publicPortal: '/public-portal/:token',
};
